// 顶级状态

export const SET_DEBUG = 'SET_DEBUG'; // debug

export const SET_TITLE = 'SET_TITLE'; // 标题

export const SET_CONTENT_CLASS = 'SET_CONTENT_CLASS'; // 标题

// =============  user userInfo 用户状态  =============

export const USER_USERINFO_CLEAR = 'USER_USERINFO_CLEAR'; // 用户信息清除

export const USER_USERINFO_UPDATE = 'USER_USERINFO_UPDATE'; // 用户信息更新

// =============  warning 报警管理信息状态  =============
export const WARNING_TYPES_UPDATE = 'WARNING_TYPES_UPDATE'; // 报警类型更新

//更新最新事故监控列表
export const RESCUE_LIST_UPDATE = 'WARNING_TYPES_UPDATE';
//更新是否弹出事故监控弹窗
export const RESCUE_POPUP_UPDATE = 'RESCUE_POPUP_UPDATE';
